import type { PokemonV2 } from "../../pokemon/pokemon";
import PokemonAbilitySelect from "../../components/PokemonAbilitySelect";

interface InputAbilityProps {
  selectedPokemon: PokemonV2;
  handleSelectAbilityForDefensePokemon: (abilityId: number) => void;
}

function InputAbility({ selectedPokemon, handleSelectAbilityForDefensePokemon }: InputAbilityProps) {
  return (
    <PokemonAbilitySelect
      pokemon={selectedPokemon}
      value={selectedPokemon.selected_ability_id}
      label="特性を選択"
      variant="sidebar"
      onChange={(abilityId) => {
        // 0（とくせい無し）も受け付ける
        if (abilityId >= 0) {
          handleSelectAbilityForDefensePokemon(abilityId);
        }
      }}
    />
  );
}

export default InputAbility;
